import { useState, useEffect } from '@wordpress/element';

export function Search({ query, setQuery, setPage, data }) {

  const [inputValue, setInputValue] = useState(query);

  useEffect(() => {
    setInputValue(query);
  }, [query]);

  // Debounced live search
  useEffect(() => {
    const trimmed = inputValue.trim();
    if (trimmed === query) return;
    const delay = setTimeout(() => {
      setPage(1);
      setQuery(inputValue.trim());
    }, 400);

    return () => clearTimeout(delay);
  }, [inputValue, query]);

  function handleClear() {
    setInputValue('');
    setQuery('');
    setPage(1);
  }

  const noResults =
    query &&
    data &&
    data.hits &&
    data.hits.length === 0;

  return (
    <div className="bill-search">
      <input
        type="text"
        placeholder="Search bills..."
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
      />

      {noResults && (
        <button
          type="button"
          className="clear-search"
          onClick={handleClear}
        >
          Clear
        </button>
      )}
    </div>
  );
}
